import { PHONE_NUMBER_FORMATS } from '../../../constants/phoneNumberFormats';

export const getPhoneNumberFormat = (nationalNumber: string): string => {
  if (nationalNumber.startsWith('4')) {
    return PHONE_NUMBER_FORMATS.Mobile;
  }

  if (nationalNumber.length < 9) {
    return PHONE_NUMBER_FORMATS.Default;
  }

  return PHONE_NUMBER_FORMATS.Landline;
};
